<template>
<div class="RedeemCodeList padding-20 bgc box-shadow">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd">创建兑换码</el-button>
        </div>
        <div class="search">
            <el-date-picker class="condition" v-model="timeSlot" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
            <el-select v-model="param.status" placeholder="状态" class="condition">
                <el-option v-for="(obj,i) in statusList" :key="i" :label="obj.name" :value="obj.code"></el-option>
            </el-select>
            <el-input v-model="param.name" placeholder="请输入关键字" class="condition key" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="兑换码名称" class-name="title" min-width="120px"></el-table-column>
            <el-table-column prop="examcode" label="兑换商品" min-width="180px">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.kmccoverurl?scope.row.kmccoverurl:bgQuesHeader" :alt="scope.row.name" preview="bbOrderList">
                        <div>
                            <el-popover placement="top" title="" trigger="hover" :content="scope.row.kmcname" popper-class="RedeemCodeList-pop">
                                <div class="text-ellipses" slot="reference">
                                    <div class="text">{{scope.row.kmcname}}</div>
                                </div>
                            </el-popover>
                            <div class="kmctype" :class="kmc(scope.row.kmctype)">{{scope.row.kmctypename}}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="statusname" label="兑换码状态" width="120px" class-name="tc" label-class-name="tc">
                <template slot-scope="scope"><div  :class="status(scope.row.status)">{{scope.row.statusname}}</div></template>
            </el-table-column>
            <el-table-column prop="expiredate" label="有效期" class-name="tc" label-class-name="tc" min-width="170px">
                <template slot-scope="scope">
                    <div class="flexcenter">
                        <div class="left" style="margin-right: 10px">至</div>
                        <div class="right">
                            <div>{{scope.row.begindate}}</div>
                            <div>{{scope.row.enddate}}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="codecount" label="兑换/发放/库存" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="datetime" label="创建时间" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column label="操作" width="180px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="[10, 100].indexOf(scope.row.status)>-1">
                            <el-button @click.stop="handleView(scope.row)" type="text" size="small">查看</el-button>
                        </span>
                        <span class="separator-btn" v-if="[0,1].indexOf(scope.row.status)>-1">
                            <el-button @click.stop="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn" v-if="[1].indexOf(scope.row.status)>-1">
                            <el-button @click.stop="handleEnd(scope.row)" type="text" size="small">停止</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleBank(scope.row)" type="text" size="small">码库</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pagesize" :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getAsseTredeemCodeList, cancelTredeemCodeInfo, exportCommonUserFormList} from 'api/operateToolApi'
import {_setClass, redeem, kmc} from 'api/enumCode'
export default {
    name: 'RedeemCodeList',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pagesize: 10,
                pageCount: 0
            },
            timeSlot: [],
            statusList: redeem.status,
            total: 0,
            param: {
                status:'', // 全部状态、1进行中、0未开始、10已结束、100已删除
                name: '',
                begintime: '',
                endtime: '',
            },
            bgQuesHeader: require('@/common/images/quesnaire/bg_ques_header.png'),
        }
    },
    mounted() {
        this._getList()
    },
    activated() {
        if (this.isRefresh) {
            this._getList()
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleAdd() {
            this.$router.push({name: 'RedeemCodeEdit'})
        },
        handleEdit(row) {
            this.$router.push({name: 'RedeemCodeEdit', query: {codeid: row.codeid}})
        },
        handleBank(row) {
            this.$router.push({name: 'RedeemCodeBank', query: {codeid: row.codeid, name: row.name, status: row.status}})
        },
        handleQuery() {
            this.page.page = 1
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this._getList()
        },
        handleView(row) {
            this.$router.push({name: 'RedeemCodeEdit', query: {codeid: row.codeid}})
        },
        handleEnd(row) {
            this.$confirm('停止该兑换码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    codeid: row.codeid
                }
                this._ending(obj)
            }).catch(() => {})
        },
        _ending(param) {
            this.setLoading(true)
            cancelTredeemCodeInfo({
                data: param,
                success: () => {
                    this.setLoading(false)
                    this.$message.success('停止成功')
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAsseTredeemCodeList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.datacount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        status () {
            return function(value) {
                return _setClass(value, redeem.status)
            }
        },
        kmc () {
            return function(value) {
                return _setClass(value, kmc.type)
            }
        },
        ...mapGetters(['isRefresh'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.RedeemCodeList {
    .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
        width: 300px;
    }
    .el-date-editor .el-range-separator{
        line-height: 26px;
    }
    .key.el-input{
        width: 240px;
    }
    .imageText{
        display: flex;
        .img{
            width: 106px;
            height: 60px;
            min-width: 106px;
            border-radius: 2px;
            margin-right: 10px;
        }
    }
    .kmctype{
        font-size: 12px;
    }
}
.RedeemCodeList-pop{
    padding: 8px;
    min-width: auto;
    width: auto !important;
    max-width: 200px;
}
</style>
